import axios from '@axios'
import { storePagination, sorting } from '@/mixins'
import moment from 'moment'
import stockCountingMaintain from './stock-counting-maintain'

const getInitialState = () => ({
  ...storePagination.state(),
  stockCountings: [],
  filters: {
    countingId: null,
    storeId: null,
    status: null,
    groupId: null,
    subgroupId: null,
    brandId: null,
    departmentId: null,
    period: {
      startDate: moment().subtract(7, 'day').startOf('day').format(),
      endDate: moment().endOf('day').format(),
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  modules: { stockCountingMaintain },

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_STOCK_COUNTINGS(state, stockCountings) {
      state.stockCountings = stockCountings
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_FILTERS(state) {
      const { filters } = getInitialState()
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, stockCountings } = getInitialState()
      state.filters = filters
      state.stockCountings = stockCountings
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchStockCountings({ commit, state }) {
      const { data } = await axios.get('/api/stock-countings', {
        params: {
          countingId: state.filters.countingId,
          storeId: state.filters.storeId,
          status: state.filters.status,
          groupId: state.filters.groupId,
          subgroupId: state.filters.subgroupId,
          brandId: state.filters.brandId,
          departmentId: state.filters.departmentId,
          from: state.filters.period.startDate,
          to: state.filters.period.endDate,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_STOCK_COUNTINGS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('CLEAN_FILTERS')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
